import React, { useContext } from 'react';
import get from 'lodash/get';
import styled from 'styled-components';

import CommaSeparatedStringArray from './CommaSeparatedStringArray';
import TopicsMultiSelect from './TopicsMultiSelect';
import FormContext from 'src/presentation/contexts/FormContext';
import { Row } from './Layout';
import { StyledSearchInput } from '@ad-scripts/presentation/components/common/multiselect_chips';

const AddTopicsControl = ({ attr, disabled, prompt }) => {
  const { workingState } = useContext(FormContext);

  const baseAttr = attr.split('.').slice(0, -1).join('.');

  const useTopicIds = get(workingState, `${baseAttr}.useTopicIds`, false);

  return (
    <>
      <StyledRow>
        {useTopicIds ? (
          <StyledTopicsMultiSelect attr={attr} className="topics-multi-select" disabled={disabled} prompt={prompt} />
        ) : (
          <CommaSeparatedStringArray attr={attr} disabled={disabled} prompt={prompt} />
        )}
      </StyledRow>
    </>
  );
};

const StyledTopicsMultiSelect = styled(TopicsMultiSelect)`
  ${StyledSearchInput} {
    width: 75%;
  }
`;

const StyledRow = styled(Row)`
  & > div {
    width: 100% !important;
  }
`;
export default AddTopicsControl;
